import React from "react";
import Loading from "../Loading";
import DownloadCsvDropdown from "./DownloadCsvDropdown";

const CredentialsTable = ({
  credentials = [],
  loading,
  page,
  limit,
  total,
  selectedIds,
  onToggleRow,
  onSelectAllPage,
  onDownloadSelected,
  onDownloadAll,
  onPageChange,
  csvDownloading,
}) => {
  const totalPages = Math.ceil(total / limit) || 1;
  const isAllOnPageSelected = credentials.length > 0 && credentials.every((r) => selectedIds.has(r.id));

  return (
    <div className="mt-8 pt-6 border-t border-gray-200">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div>
          <h3 className="text-base font-semibold text-gray-900">All dummy user credentials</h3>
          <p className="text-sm text-gray-500 mt-0.5">
            Use this table to see which email has which password. Select rows and download CSV (Selected or All).
          </p>
        </div>
        <DownloadCsvDropdown
          selectedCount={selectedIds.size}
          loading={csvDownloading}
          onDownloadSelected={onDownloadSelected}
          onDownloadAll={onDownloadAll}
        />
      </div>
      {loading ? (
         <div className="text-center py-6">
         <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-red-500 border-t-transparent" />
         <p className="mt-4 text-gray-600 font-medium text-sm">
           Loading dummy user credentials...
         </p>
       </div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="min-w-full text-xs md:text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-3 py-2 text-left font-semibold text-gray-600 w-10">
                    <input
                      type="checkbox"
                      checked={isAllOnPageSelected}
                      onChange={(e) => onSelectAllPage(e.target.checked)}
                      className="rounded border-gray-300"
                      aria-label="Select all on page"
                    />
                  </th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">#</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">User ID</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">Email</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">Password</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">Gender</th>
                  <th className="px-3 py-2 text-left font-semibold text-gray-600">Created</th>
                </tr>
              </thead>
              <tbody>
                {credentials.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="px-3 py-6 text-center text-gray-500">
                      No dummy user credentials yet. Create users with Auto or Manual above.
                    </td>
                  </tr>
                ) : (
                  credentials.map((row, idx) => (
                    <tr key={row.id} className="border-t border-gray-100 hover:bg-gray-50/50">
                      <td className="px-3 py-2">
                        <input
                          type="checkbox"
                          checked={selectedIds.has(row.id)}
                          onChange={() => onToggleRow(row.id)}
                          className="rounded border-gray-300"
                          aria-label={`Select row ${row.id}`}
                        />
                      </td>
                      <td className="px-3 py-2">{(page - 1) * limit + idx + 1}</td>
                      <td className="px-3 py-2">{row.userId}</td>
                      <td className="px-3 py-2 font-mono text-gray-900">{row.email}</td>
                      <td className="px-3 py-2 font-mono text-gray-700">{row.password}</td>
                      <td className="px-3 py-2 text-gray-600">{row.gender ?? "—"}</td>
                      <td className="px-3 py-2 text-gray-600">
                        {row.createdAt ? new Date(row.createdAt).toLocaleString() : "—"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {total > limit && onPageChange && (
            <div className="mt-3 flex items-center justify-between">
              <span className="text-sm text-gray-600">
                Page {page} of {totalPages} (Total: {total})
              </span>
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => onPageChange(page - 1)}
                  disabled={page <= 1}
                  className="rounded border border-gray-300 px-3 py-1 text-sm disabled:opacity-50"
                >
                  Previous
                </button>
                <button
                  type="button"
                  onClick={() => onPageChange(page + 1)}
                  disabled={page >= totalPages}
                  className="rounded border border-gray-300 px-3 py-1 text-sm disabled:opacity-50"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CredentialsTable;
